// Etiquetas de gráficos compartidas del mundo directivo.
//
// Etiqueta de valor ADAPTATIVA para barras: mide la barra (ancho y alto vs
// largo del texto rotado -90°) y decide dónde dibujarse:
//   - cabe COMPLETA adentro → dentro de la columna, anclada a la base, con la
//     tinta que contraste con el relleno de esa serie;
//   - no cabe (barra bajita) → ARRIBA de la barra, en tinta de texto normal.
// Nunca números cortados; el dato exacto sigue viviendo en el tooltip.
// En barras más angostas que el alto del texto rotado no se renderiza.

import { compacto } from '../lib/formato';

const ANCHO_MINIMO_BARRA = 14;

function crearEtiquetaValorBarra(tintaDentro: string) {
  return function EtiquetaValorBarra(props: {
    x?: number | string;
    y?: number | string;
    width?: number | string;
    height?: number | string;
    value?: unknown;
  }) {
    const x = Number(props.x ?? 0);
    const y = Number(props.y ?? 0);
    const width = Number(props.width ?? 0);
    const height = Number(props.height ?? 0);
    const value = Number(props.value ?? 0);
    if (!value || value <= 0 || width < ANCHO_MINIMO_BARRA) return null;

    const texto = compacto(value);
    const largoTexto = texto.length * 6.5 + 14;
    const cx = x + width / 2 + 3.5;

    if (height >= largoTexto) {
      // Cabe completa: adentro, anclada a la base de la columna.
      const cy = y + height - 7;
      return (
        <text
          x={cx}
          y={cy}
          transform={`rotate(-90 ${cx} ${cy})`}
          textAnchor="start"
          fontSize={10.5}
          fontWeight={700}
          letterSpacing="0.02em"
          fill={tintaDentro}
        >
          {texto}
        </text>
      );
    }

    // Barra bajita: el valor va arriba de la barra, en tinta de texto.
    const cy = y - 5;
    return (
      <text
        x={cx}
        y={cy}
        transform={`rotate(-90 ${cx} ${cy})`}
        textAnchor="start"
        fontSize={10}
        fontWeight={600}
        letterSpacing="0.02em"
        fill="var(--color-fg-secondary)"
      >
        {texto}
      </text>
    );
  };
}

/** Barras oscuras (Producción, relleno fg-tertiary): tinta clara adentro. */
export const LabelValorProduccion = crearEtiquetaValorBarra('var(--color-surface-base)');

/** Barras claras (Meta capacidad, relleno border-strong): tinta de texto adentro. */
export const LabelValorMeta = crearEtiquetaValorBarra('var(--color-fg-secondary)');
